import { Box } from "@chakra-ui/layout";
import { useDispatch } from "react-redux";
import { closeSlider, setAutocompleteVisibility } from "../../redux/actions/actions";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";

export default function WithLayout(WrappedComponent) {
    const dispatch = useDispatch()
    return (props) => {
        return (
            <Box d='flex' maxW='100vw'>
                <Sidebar />
                <Box
                    d='flex'
                    flexDirection='column'
                    flexGrow='1'
                    bgColor='#f8f8f8'
                    onClick={(e) => {
                        e.stopPropagation()
                        dispatch(setAutocompleteVisibility(false))
                        dispatch(closeSlider())
                    }}
                >
                    <Header />
                    <WrappedComponent {...props}/>
                </Box>
            </Box>
        );
    }
}